import type { ReactNode } from "react";

import { useProPreview } from "../lib/useProPreview";

// Показывает содержимое, только если платное включено ссылкой с `?pro=1` (`lib/proPreview`).
export const ProPreview = ({ children }: { children: ReactNode }) =>
  useProPreview() ? children : null;
